function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7882"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7882"] = parcelRequire;
}
parcelRequire.register("3ueMA", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $289fa3fab82a0cd6$export$6503ec6e8aabbaf; }, function (v) { return $289fa3fab82a0cd6$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $289fa3fab82a0cd6$export$f7ad0328861e2f03; }, function (v) { return $289fa3fab82a0cd6$export$f7ad0328861e2f03 = v; });
var $289fa3fab82a0cd6$export$6503ec6e8aabbaf;
var $289fa3fab82a0cd6$export$f7ad0328861e2f03;
"use strict";
var $289fa3fab82a0cd6$var$mapping = {};
function $289fa3fab82a0cd6$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$289fa3fab82a0cd6$var$mapping[keys[i]] = pairs[keys[i]];
}
function $289fa3fab82a0cd6$var$resolve(id) {
    var resolved = $289fa3fab82a0cd6$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$289fa3fab82a0cd6$export$6503ec6e8aabbaf = $289fa3fab82a0cd6$var$register;
$289fa3fab82a0cd6$export$f7ad0328861e2f03 = $289fa3fab82a0cd6$var$resolve;

});

var $2bc8b3b80a3b3890$exports = {};

(parcelRequire("3ueMA")).register(JSON.parse('{"k5XeJ":"index.3cac1844.js","bH8gT":"pandora-logo.5abbd1dd.png"}'));


//# sourceMappingURL=index.b42a7020.js.map
